'use client';

import styles from '@/app/ui/components/pagination/pagination.module.scss';
import React from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import clsx from 'clsx';
import { PrefetchOnHoverLink } from '@/app/ui/components/prefetchonhoverlink';

export function PaginationItem(props: { currentPage: string; item: string }) {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const createPageURL = (pageNumber: number | string) => {
    const params = new URLSearchParams(searchParams ?? '');

    if (pageNumber.toString() === '1') {
      params.delete('page');
    } else {
      params.set('page', pageNumber.toString());
    }

    const paramString = params.toString();
    return paramString ? `${pathname}?${paramString}` : pathname;
  };

  if (props.item.toString() === props.currentPage.toString() || props.item === '...')
    return (
      <li
        className={`${clsx(
          styles.paginationItem,
          props.currentPage.toString() === props.item.toString() ? styles.active : ''
        )}`}>
        <span>{props.item}</span>
      </li>
    );

  return (
    <PrefetchOnHoverLink href={createPageURL(props.item)} className="text-decoration-none">
      <li className={`${clsx(styles.paginationItem, props.currentPage === props.item ? styles.active : '')}`}>
        <span>{props.item}</span>
      </li>
    </PrefetchOnHoverLink>
  );
}
